/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { NgModule } from '@angular/core';
import { DepartmentDetailComponent } from '@departments/department-detail/department-detail.component';
import { DepartmentsComponent } from '@departments/departments/departments.component';
import { SharedModule } from '@shared/shared.module';

@NgModule({
  declarations: [
    DepartmentsComponent,
    DepartmentDetailComponent
  ],
  imports: [
    SharedModule
  ]
})
export class DepartmentsModule { }
